import { render, staticRenderFns } from "./DynamicVectorProperties.vue?vue&type=template&id=79590801"
import script from "./DynamicVectorProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicVectorProperties.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports